<template>
<div class="special">
  <div class="plk-header">普莱柯专场</div>
  <div class="special-header-app" v-show="isApp">
    <div class="app-left">
      <div class="app-left-img">
        <img src="../../src/assets/img/144.png">
      </div>
      <div class="app-left-text">终端客户APP 特点介绍</div>
    </div>
    <div class="app-right">
      <div class="app-right-text" @click="downloadapp">下载APP</div>
      <div class="app-right-img" @click="closeApp">
        <img src="../../src/assets/img/Delete@2x.png" alt="">
      </div>
    </div>
  </div>
  <div class="special-header">
    <div class="special-header-navimg">
      <img :src="ltbImg">
    </div>
    <div class="navimg-time">
      <div class="time">
        <div class="time-text">截止时间:</div>
        <div class="time-list">{{ltbEndTime}}</div>
      </div>
    </div>
  </div>
  <div class="special-list">

    <div class="special-list-box" v-for="item in items" :key="index">
      <div class="box-left">
        <img :src="item.pictureUrl" alt="">
      </div>
      <div class="box-right">
        <div class="box-right-title">{{item.ltbTitle}}</div>
        <div class="box-right-price">
          <p>¥{{item.ltbPrice}}</p>
          <span>¥{{item.goodsRetailPrice}}</span>
        </div>
      </div>
    </div>

  </div>
  <div class="downloadapp" @click="downloadapp">下载APP</div>
</div>
</template>

<script>
import { specialList } from '@/api/resetApi.js'

export default {
  name: 'detail',
  data() {
    return {
      ltbId: '',
      page: 1,
      size: 5,
      ltbImg: '',
      items: [],
      isApp: true,
    }
  },
  created(){
    if(this.$route.query.ltbId){
      this.ltbId = this.$route.query.ltbId
    }
    this.specialList()
  },
  methods: {
    downloadapp() {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.sslab.customer'
    },
    closeApp() {
      this.isApp = false;
    },
    async specialList() {
      let data = {
        ltbId: this.ltbId,
        page: this.page,
        size: this.size,
      }
      const res = await specialList(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.ltbImg = res.data.data.ltbImg
          this.items = res.data.data.psLimitTimeBuyVos
          this.ltbEndTime = res.data.data.ltbEndTime.substr(0,10)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .special {
    background: rgba(247,247,247,1);;
  }
  .special-header-app {
    display: flex;
    width: 100%;
    height: 0.5rem;
    font-size: 0;
    background:rgba(234,71,71,1);
    .app-left {
      flex: 1;
      align-self: center;
      display: flex;
      .app-left-img {
        flex: 0 0 0.4rem;
        margin-left: 0.1rem;
        align-self: center;
        img {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 0.05rem;
        }
      }
      .app-left-text {
        flex: 0 0 0.9rem;
        margin-left: 0.05rem;
        align-self: center;
        text-align: left;
        line-height: 0.18rem;
        font-size: 0.14rem;
        color: #fff;
      }
    }
    .app-right {
      flex: 0 0 1.1rem;
      display: flex;
      .app-right-text {
        flex: 0 0 0.8rem;
        align-self: center;
        height: 0.3rem;
        line-height: 0.3rem;
        background: #fff;
        font-size: 0.14rem;
        color: #EA4747;
        border-radius: 0.16rem;
      }
      .app-right-img {
        flex: 0 0 0.18rem;
        margin-left: 0.08rem;
        align-self: center;
        img {
          width: 0.18rem;
          height: 0.18rem;
        }
      }
    }
  }
  .special-header {
    width: 100%;
    height: 1.38rem;
    position: relative;
    background:rgba(234,71,71,1);
    .special-header-navimg {
      position: absolute;
      bottom: -0.2rem;
      left: 0.1rem;
      font-size: 0;
      img {
        width: 3.55rem;
        height: 1.44rem;
      }
    }
    .navimg-time {
      position: absolute;
      bottom: 0rem;
      left: 0.2rem;
      width: 90%;
      font-size: 0;
      .time {
        display: flex;
        .time-text {
          flex: 0 0 0.5rem;
          font-size: 0.1rem;
          color: #fff;
        }
        .time-list {
          flex: 1;
          text-align:left;
          font-size: 0.1rem;
          color: #fff;
          span {
            display: inline-block;
            width: 0.2rem;
            height: 0.2rem;
            line-height: 0.2rem;
            text-align: center;
            background:rgba(20,34,191,1);
            font-size: 0.14rem;
            color: #fff;
          }
          em {
            display: inline-block;
            width: 0.1rem;
            height: 0.1rem;
            line-height: 0.1rem;
            text-align: center;
            font-size: 0.14rem;
            font-weight: bold;
            color: #fff;
          }
        }
      }
    }
  }
  .special-list {
    padding: 0.4rem 0.1rem 0.5rem;
    .special-list-box {
      display: flex;
      background: #fff;
      border-radius: 0.05rem;
      margin-bottom: 0.1rem;
      .box-left {
        flex: 0 0 1.2rem;
        img {
          margin: 0.15rem 0 0 0.1rem;
          width: 1.2rem;
          height: 1.2rem;
        }
      }
      .box-right {
        flex: 1;
        position: relative;
        margin-left: 0.1rem;
        text-align: left;
        .box-right-title {
          position: absolute;
          left: 0;
          top: 0.15rem;
          padding-right: 0.1rem;
          font-size: 0.14rem;
          color: #000;
        }
        .box-right-price {
          position: absolute;
          left: 0;
          bottom: 0.15rem;
          width: 100%;
          font-size: 0;
          p {
            padding-bottom: 0.05rem;
            font-size: 0.16rem;
            font-weight: bold;
            color: #F62E2E;
          }
          span {
            text-decoration: line-through;
            font-size: 0.12rem;
            color: #9B9B9B;
          }
        }
      }
    }
  }
  .plk-header {
    width: 100%;
    height: 0.5rem;
    text-align: center;
    line-height: 0.5rem;
    font-size: 0.16rem;
    color: #181818;
    background: #fff;
  }
  .downloadapp {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0.5rem;
    text-align: center;
    line-height: 0.5rem;
    font-size: 0.16rem;
    color: #fff;
    background:rgba(234,71,71,1);
  }
</style>